import { EllipsisTooltip } from '@src/components/common';
import styled from 'styled-components';

export const StyledEllipsisTooltip = styled(EllipsisTooltip)`
  max-width: 500px;
  width: auto;
  line-height: 1.25;
  font-size: 24px;
  overflow: visible;
  overflow-x: clip;
`;
